import { ComparativeDisplayType } from 'types/GlobalKpiOption'

const ORDER = [
  ComparativeDisplayType.VALUE,
  ComparativeDisplayType.PERCENTAGE,
  ComparativeDisplayType.PERCENTAGE_AND_VALUE,
  ComparativeDisplayType.PREVIOUS_VALUE
]

/** The display types to pick from: the ones that show a comparison. */
export const getOptions = (
  options: ComparativeDisplayType[]
): ComparativeDisplayType[] =>
  options
    .filter((option) => option !== ComparativeDisplayType.HIDDEN)
    .sort((a, b) => ORDER.indexOf(a) - ORDER.indexOf(b))
